import React from "react";
import Slider from "react-slick";

import "../../styles/testimonial.css";

const Testimonial = () => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 1000,
    swipeToSlide: true,
    autoplaySpeed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <Slider {...settings}>
      <div className="testimonial py-4 px-3">
        <p className="section__description">
          Sankhu Car Rental made my journey to Maasai Mara unforgettable. The
          vehicle was comfortable, and the driver's local insights enhanced the
          experience.
        </p>

        <div className="mt-3 d-flex align-items-center gap-4">
          <div>
            <h6 className="mb-0 mt-3">Jane from Nairobi</h6>
            <p className="section__description">Customer</p>
          </div>
        </div>
      </div>

      <div className="testimonial py-4 px-3">
        <p className="section__description">
          I explored Lake Nakuru with Sankhu. The vehicle was top-notch, and the
          personalized tour brought the beauty of Nakuru National Park to life.
        </p>

        <div className="mt-3 d-flex align-items-center gap-4">
          <div>
            <h6 className="mb-0 mt-3">David from Nakuru</h6>
            <p className="section__description">Customer</p>
          </div>
        </div>
      </div>

      <div className="testimonial py-4 px-3">
        <p className="section__description">
          Thanks to Sankhu's unlimited kilometer car rental, we freely roamed
          the coastal wonders of Diani. The car's reliability made our vacation
          truly exceptional.
        </p>

        <div className="mt-3 d-flex align-items-center gap-4">
          <div>
            <h6 className="mb-0 mt-3">Grace from Diani</h6>
            <p className="section__description">Customer</p>
          </div>
        </div>
      </div>

      <div className="testimonial py-4 px-3">
        <p className="section__description">
          Sankhu's airport transfer service was punctual and professional. A
          stress-free arrival marked the beginning of our exciting journey
          through Naivasha's stunning landscapes.
        </p>

        <div className="mt-3 d-flex align-items-center gap-4">
          <div>
            <h6 className="mb-0 mt-3">Joseph from Naivasha</h6>
            <p className="section__description">Customer</p>
          </div>
        </div>
      </div>
    </Slider>
  );
};

export default Testimonial;
